import axios from 'axios';
import { HEADERS } from '../../../../../API/UrlAndPaths';

// Get products from stock moves
export const getProductsFromStockMovesAPI = async (body) => {
  try {
    const response = await axios.post('inventory/getProductsFromStockMoves', body, HEADERS);
    return response.data;
  } catch (error) {
    console.error('Error getting products from stock moves:', error);
    return { success: false, data: [] };
  }
};

// Save Physical Closing Entries
export const savePhysicalClosingAPI = async (body) => {
  try {
    const res = await axios.post("inventory/savePhysicalClosing", body, HEADERS);
    if (res.status === 200) {
      return { success: true, data: res.data };
    }
  } catch (err) {
    console.error('Save Physical Closing Error:', err.response);
    return { success: false, error: err.response?.data };
  }
};

// Get Physical Closing Entries
export const getPhysicalClosingAPI = async (body) => {
  try {
    const res = await axios.post("inventory/getPhysicalClosing", body, HEADERS);
    if (res.status === 200) {
      return { success: true, data: res.data };
    }
  } catch (err) {
    console.error('Get Physical Closing Error:', err.response);
    return { success: false, error: err.response?.data };
  }
};
